import React from 'react';
import ContactListBase from './ContactListBase';

// Lists all organizations, whatever their contact type
const OrganizationList: React.FC = () => {
    return (
        <ContactListBase
            listKey='contact_organization'
            objectName='organization.general.object_name'
            defaultParams={{ entity_type: 'organization' }}
            formLinkedItem={{ entity_type: 'organization' }}
            showTypeFilter
        />
    );
};

export default OrganizationList;
